import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'TemplatesForm',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    hasFallbacks() {
      return this.proxy?.fallbacks?.length > 0
    },

    canGetUsers() {
      return this.checkPermissions(`advanced.${Services.users}.get`)
    },

    canCreateTemplates() {
      return this.checkPermissions(`advanced.${Services.templates}.create`, permissionPresets.resellerUp)
    },

    canUpdateTemplates() {
      return this.checkPermissions(`advanced.${Services.templates}.update`, permissionPresets.resellerUp)
    }
  },

  render
}
